import GeneralBtn from './GeneralBtn';

export default function ExportBtn(props: { onExport: () => Promise<void>; isShow?: boolean }) {
  const { onExport, isShow } = props;

  if (!isShow) return <></>;

  return (
    <GeneralBtn
      label="export"
      onClick={onExport}
    />
  );
}
